import service from '@/utils/request'; // GetBairunStationBasePriceOpLogList 分页获取油站挂牌价操作记录
// @Tags Station
// @Summary 分页获取油站挂牌价操作记录
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationBasePriceOpLogSearch true "分页获取油站挂牌价操作记录"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationOpLog/getBasePriceOpLogList [get]

export var getBairunStationBasePriceOpLogList = function getBairunStationBasePriceOpLogList(params) {
  return service({
    url: '/stationOpLog/getBasePriceOpLogList',
    method: 'get',
    params: params
  });
};